import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminInquiries = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/inquiries`)
      .then((r) => mounted && setItems(r.data))
      .catch((e) => mounted && setError(e?.message || "Failed to load"))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main
      data-testid="admin-inquiries-page"
      className="min-h-screen bg-[var(--lt-peace)] py-24 px-6"
    >
      <div className="container mx-auto max-w-5xl">
        <h1
          className="font-display tracking-editorial text-[var(--lt-charcoal)] mb-2"
          style={{ fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 600 }}
        >
          Inquiries
        </h1>
        <p className="text-[var(--lt-bark)] mb-10 text-sm">
          Internal admin view — Little Things Studio
        </p>

        {loading && <p className="text-[var(--lt-bark)]">Loading…</p>}
        {error && (
          <p className="text-red-700 text-sm" data-testid="admin-error">
            {error}
          </p>
        )}

        {!loading && !error && items.length === 0 && (
          <p className="text-[var(--lt-bark)]/70 italic" data-testid="admin-empty">
            No inquiries yet.
          </p>
        )}

        <ul className="divide-y divide-[var(--lt-line)] border-t border-[var(--lt-line)]">
          {items.map((it) => (
            <li
              key={it.id}
              className="py-6 grid grid-cols-1 md:grid-cols-3 gap-4"
              data-testid={`admin-inquiry-${it.id}`}
            >
              <div>
                <p
                  className="font-display text-[var(--lt-charcoal)] text-lg"
                  style={{ fontWeight: 600 }}
                >
                  {it.name}
                </p>
                <p className="text-sm text-[var(--lt-bark)]">{it.email}</p>
                {it.company && (
                  <p className="text-xs text-[var(--lt-bark)]/70 mt-1">{it.company}</p>
                )}
                <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--lt-bark)]/60 mt-3">
                  {it.project_type}
                </p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm text-[var(--lt-charcoal)] whitespace-pre-wrap leading-relaxed">
                  {it.message}
                </p>
                <p className="text-xs text-[var(--lt-bark)]/60 mt-3">
                  {new Date(it.created_at).toLocaleString()}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
};

export default AdminInquiries;
